import {Injectable} from '@angular/core';
import {ConfermaAppuntamentoStore} from './confermaAppuntamento.store';
import {AbstractInterfaceDataQuery} from '../interfaceDataModel';
import {IID_CONFERMA_APPUNTAMENTO} from '@common/interfaces/interfaceData';
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.IID_CONFERMA_APPUNTAMENTO)
export class ConfermaAppuntamentoQuery extends AbstractInterfaceDataQuery<IID_CONFERMA_APPUNTAMENTO> {
  all$ = this.selectAll();

  constructor(protected store: ConfermaAppuntamentoStore) {
    super(store);
  }
}
